import * as React from "react";

import { observer } from "mobx-react";
import { Layout } from "antd";
import { SidePanel } from "./components/sidePanel/SidePanel";
import { PermissionsPanel } from "./components/permissionsPanel/PermissionsPanel";

const { Content } = Layout;

@observer
export class PermissionsContainer extends React.Component<any> {
  render() {
    return (
      <Layout className="permissions--container">
        <div className="permissionSidePanel">
          <SidePanel />
        </div>

        <Content style={{ background: "#f7f7f7" }}>
          <PermissionsPanel />
        </Content>
      </Layout>
    );
  }
}
